import {ErrorContract} from '../../types/error';

export enum ErrorActionTypes {
    SetError = 'ERROR/setError',
}

export type ErrorAction =
    | { type: ErrorActionTypes.SetError, error: ErrorContract };
